import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND, VALUES, DIFFERENTIATORS } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";
import aboutTeamAsset from "@/assets/about-team-vrp-flooring.webp.asset.json";


const About = () => {
  return (
    <Layout>
      <Seo
        title="About VRP Flooring LLC | Danbury CT Flooring Contractor"
        description="VRP Flooring LLC is a locally owned Danbury, CT flooring contractor specializing in residential and commercial flooring installation, replacement and renovation since 2001."
        jsonLd={[
          orgSchema(),
          breadcrumbSchema([
            { name: "Home", url: BRAND.website },
            { name: "About", url: `${BRAND.website}/about` },
          ]),
        ]}
      />
      <section className="container-page py-12 md:py-16">
        <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "About" }]} />
        <div className="mt-6 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <p className="eyebrow mb-4 text-accentInk">About VRP Flooring LLC</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold mb-6">Residential &amp; commercial flooring specialists in Danbury, Connecticut.</h1>
            <p className="text-muted-foreground text-lg leading-relaxed mb-4">
              VRP Flooring LLC is a locally owned and operated flooring contractor serving Danbury and the surrounding Connecticut towns. We specialize in the installation, replacement and renovation of residential and commercial flooring — hardwood, luxury vinyl, laminate and tile.
            </p>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              Shop in your own home or business: we bring hundreds of samples to you, with convenient same-day appointments and next-day installation. Every major brand, color and texture, at a price you can afford — backed by a 100% satisfaction guarantee.
            </p>
            <CTAGroup />
          </div>
          <div>
            <img src={aboutTeamAsset.url} alt="VRP Flooring LLC team standing in front of company trucks in Danbury, Connecticut" className="rounded-lg shadow-elev w-full max-w-[480px] mx-auto" loading="lazy" width={1122} height={1402} />
          </div>
        </div>
      </section>

      <section className="bg-secondary/40 py-20">
        <div className="container-page grid md:grid-cols-3 gap-8">
          <div>
            <h2 className="font-display text-2xl font-bold mb-3">Our Mission</h2>
            <p className="text-muted-foreground leading-relaxed">To make new floors simple and affordable — bringing the showroom to your door, installing with precision, and standing behind every square foot we lay.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold mb-3">Our Vision</h2>
            <p className="text-muted-foreground leading-relaxed">To be Connecticut's most trusted flooring contractor for residential and commercial installation, replacement and renovation.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold mb-3">Our Promise</h2>
            <p className="text-muted-foreground leading-relaxed">A 100% satisfaction guarantee. Clean work, honest pricing, and floors finished to the standard we'd want in our own homes.</p>
          </div>
        </div>
      </section>

      <section className="container-page py-20">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-10 text-center">Our Values</h2>
        <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-5">
          {VALUES.map((v) => (
            <div key={v.title} className="card-elev p-6">
              <h3 className="font-semibold text-lg mb-2">{v.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-foreground text-background py-20">
        <div className="container-page max-w-3xl text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-6">What sets us apart</h2>
          <ul className="grid gap-3 md:grid-cols-2 text-left">
            {DIFFERENTIATORS.map((d) => (
              <li key={d} className="flex items-start gap-3">
                <span className="text-accent mt-1">✓</span>
                <span>{d}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10">
            <CTAGroup variant="onDark" className="justify-center" />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
